/**
 * SSR 환경에서 사용할 dummy storage
 */
export class DummyStorage implements Storage {
  private store: Record<string, string> = {};

  getItem(key: string): string | null {
    return this.store[key] || null;
  }

  setItem(key: string, value: string): void {
    this.store[key] = value;
  }

  removeItem(key: string): void {
    delete this.store[key];
  }

  clear(): void {
    this.store = {};
  }

  get length(): number {
    return Object.keys(this.store).length;
  }

  key(index: number): string | null {
    const keys = Object.keys(this.store);
    return keys[index] || null;
  }
}

export const dummyLocalStorage = new DummyStorage();

export function safeGetLocalStorage(): Storage {
  if (typeof window !== 'undefined') {
    return localStorage;
  }

  return dummyLocalStorage;
}
